import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import * as actions from "./store/actions/action";
import { connect } from "react-redux";
import "./App.css";
import Login from "./Containers/Login/Login";
import Panel from "./Containers/Panel/Panel";
import Notfound from "./Containers/Notfound/Notfound";
import Requests from "./Containers/Requests/Requests";
import Learners from "./Containers/Learners/Learners";
import ReservedList from "./Containers/ReservedList/ReservedList";
import NewRequest from "./Containers/NewRequest/NewRequest";
import Report from "./Containers/Report/Report";
import TrackingList from "./Containers/TrackingList/TrackingList";
import Settings from "./Containers/Settings/Settings";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import Student from "./Containers/Student/Student";
import LoadingPage from "./Containers/LoadingPage/LoadingPage";

const SignUpForm = React.lazy(() =>
  import("./Containers/SignUpForm/SignUpForm")
);
const PlacementTestResult = React.lazy(() =>
  import("./Containers/PlacementTestResult/PlacementTestResult")
);
const UserAuth = React.lazy(() =>
  import("./Containers/UserAuth/UserAuth")
);

class App extends Component {
  componentWillMount() {
    const token = localStorage.getItem("token");
    if (token) {
      this.props.setToken(token);
    }
    const theme = localStorage.getItem("theme");
    if (!theme) {
      localStorage.setItem("theme", "default");
    }
  }
  render() {
    return (
      <div className="App">
   

        <Routes>
          <Route path="/SignUpForm/auth" element={<UserAuth target="SignUpForm" />} />
          <Route
            path="/SignUpForm"
            element={
              <React.Suspense fallback={<LoadingPage />}>
                <SignUpForm />
              </React.Suspense>
            }
          />
          <Route path="/PlacementTestResult/auth" element={<UserAuth target="PlacementTestResult" />} />
          <Route
            path="/PlacementTestResult"
            element={
              <React.Suspense fallback={<LoadingPage />}>
                <PlacementTestResult />
              </React.Suspense>
            }
          />

          <Route path="/Login" element={<Login />} />
          <Route path="/" element={<Panel />}>
            <Route
              index
              path="Learners"
              element={
                <ProtectedRoute>
                  <Learners />
                </ProtectedRoute>
              }
            />
            <Route
              path="Requests"
              element={
                <ProtectedRoute>
                  <Requests />
                </ProtectedRoute>
              }
            />
            <Route
              path="ReservedList"
              element={
                <ProtectedRoute>
                  <ReservedList />
                </ProtectedRoute>
              }
            />
            <Route
              path="TrackingList"
              element={
                <ProtectedRoute>
                  <TrackingList />
                </ProtectedRoute>
              }
            />
            <Route
              path="NewRequest"
              element={
                <ProtectedRoute>
                  <NewRequest />
                </ProtectedRoute>
              }
            />
            <Route
              path="Settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="Report"
              element={
                <ProtectedRoute>
                  <Report />
                </ProtectedRoute>
              }
            />
            <Route
              path="Student/:id"
              element={
                <ProtectedRoute>
                  <Student />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<Notfound />} />
        </Routes>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    token: state.token,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setToken: (token) => dispatch(actions.TokenSetter(token)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
